















import PageHeader from '@/components/PageHeader.vue'
import Translation from '@/mixins/Translation'
import {Biz} from '@/store/modules/biz/types'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const biz = namespace('biz')

@Component({
  components: {PageHeader}
})
export default class ChangeBizPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string

  @biz.State('bizs') bizs: Biz[]
  @biz.State('id') bizId: string

  isSelected(id): boolean {
    return this.bizId === id
  }

  onClose() {
    this.$emit('close')
  }

  onClickBiz(id: string) {
    if(this.bizId !== id) {
      this.$emit('select-biz', id)
    }
    this.onClose()
  }

  onClickAdd() {
    this.$emit('add-biz')
    this.onClose()
  }
}
